<template>
  <section id="products-form">
    <div class="titulo-page" v-if="products.length > 0">
      {{$t("Adicionais")}}
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="row justify-content-center" v-if="products.length > 0">
          <div
            v-for="product in products" 
            :key="product.id"
            :class="{
              'col-md-4': true,
              'col-12': true,
              'justify-content-center': true,
              'align-items-center': true,
              'products-item': true,
              'active': isSelected(product)
            }"
          >
            <div class="card p-4 h-100">
              <img class="products-image" v-if="product.image" :src="product.image" :alt="product.title">
              <h4 class="products-title mt-4 mb-1" v-html="product.title"></h4>
              <small class="products-value mb-2">
                <i>{{(product.value / 100) | currency}}</i>
                <span v-if="product.periodicity == 'monthly'"> / mês </span>
                <span v-else-if="product.periodicity == 'yearly'"> / ano </span>
              </small>
              <div class="products-description" v-html="product.description"></div>
              <div class="mt-2 d-flex justify-content-end">
                <button
                  type="button"
                  :class="{'btn': true, 'btn-primary': !isSelected(product), 'btn-danger': isSelected(product)}"
                  @click="toggle(product)"
                >
                  {{ isSelected(product) ? 'Remover' : 'Adicionar' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert
          variant="danger"
          :show="error.show"
          v-model="error.show"
        >
          <div>{{ error.message }}</div>
        </b-alert>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      selected: [],
      error: {
        show: false,
        message: ''
      }
    }
  },
  props: {
    products: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: Array,
    }
  },
  methods: {
    toggle(product) {
      if (this.isSelected(product)) {
        this.selected = this.selected.filter((i) => i.id != product.id);
      } else {
        this.selected.push(product);
      }

      this.$emit("input", this.selected);
    },
    isSelected(product) {
      return this.selected.filter(i => i.id == product.id).length > 0
    }
  },
})
</script>
